module.exports = __webpack_public_path__ + "media/images/phone-call-eedec6cb96683d83997f621e6f298ce1.png";